import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
//import { ArquivoUpload } from '@core/models/arquivo';
import { NotificationService } from '@core/services/notification.service';
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { MAX_UPLOAD_FILE_SIZE_BYTES, MAX_UPLOAD_FILE_SIZE_MB } from '@core/config/file-type';
import { toRawFile } from '@core/services/arquivo.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-upload-arquivo',
  templateUrl: './upload-arquivo.component.html',
  styleUrls: ['./upload-arquivo.component.scss']
})
export class UploadArquivoComponent implements OnInit {

  @Input() arquivos: any[] = [];
  @Input()
  tiposArquivos: string[] = [];
  @Input()
  limite!: number;

  @Output() arquivosEmit = new EventEmitter();

  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true,
    showDownloadIcon: false
  };
  situacaoArquivosCarregados: boolean[] = [];
  erroUpload!: boolean;
  carregandoArquivos!: boolean;
  acceptedFileTypes: string = '';
  readonly tamanhoMaximoMb = MAX_UPLOAD_FILE_SIZE_MB;

  constructor(private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.acceptedFileTypes = this.tiposArquivos.join(',');
  }

  // beforeUpload = (file: File | NzUploadFile): boolean => {

  //   console.log('file', file);

  //   let arquivo = <any>{};
  //   //  let arquivo = new ArquivoUpload();
  //   arquivo = {};
  //   arquivo.percent = 25;
  //   arquivo.nome = file.name;
  //   let splitName = file.name.split('.');
  //   arquivo.extensao = splitName[splitName.length - 1];
  //   this.arquivos.push(arquivo);
  //   this.situacaoArquivosCarregados.push(true);
  //   this.atualizarEstadosUpload();
  //   let index = this.arquivos.indexOf(arquivo);
  //   const reader = new FileReader();
  //   reader.readAsDataURL(<File>file);
  //   try {
  //     reader.onload = () => {
  //       if (reader.result) {
  //         (file as any)['url'] = reader.result.toString();
  //         this.arquivos[index].dados = (file as any)['url'].split(',')[1];
  //         this.arquivos[index].conteudo = (file as any)['url'];
  //         this.arquivos[index].file = (file as any);
  //         this.arquivos[index].percent = 100;
  //         this.situacaoArquivosCarregados.pop();
  //         this.atualizarEstadosUpload();
  //         this.arquivosEmit.emit(this.arquivos);
  //       }
  //     }
  //     reader.onerror = error => {
  //       this.arquivos[index].percent = 100;
  //       this.arquivos[index].erro = true;
  //       this.notificationService.error('Atenção', 'Ocorreu um erro inesperado ao realizar o upload');
  //       this.situacaoArquivosCarregados.pop();
  //       this.atualizarEstadosUpload();
  //     }
  //   } catch {
  //     this.arquivos[index].percent = 100;
  //     this.arquivos[index].erro = true;
  //     this.notificationService.error('Atenção', 'Ocorreu um erro inesperado ao realizar o upload');
  //     this.situacaoArquivosCarregados.pop();
  //     this.atualizarEstadosUpload();
  //   }

  //   return false;
  // };

  beforeUpload = (file: NzUploadFile): boolean => {
    const rawFile = toRawFile(file);
    if (rawFile?.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      this.notificationService.error(
        'Arquivo muito grande',
        `O arquivo deve ter no máximo ${MAX_UPLOAD_FILE_SIZE_MB} MB.`
      );
      return false;
    }
    return true;
  };

  customRequest = (item: NzUploadXHRArgs): Subscription => {
    let arquivo: any = {};
    arquivo.percent = 25;
    arquivo.nome = item.file.name;
    const splitName = item.file.name.split('.');
    arquivo.extensao = splitName[splitName.length - 1];

    this.arquivos.push(arquivo);
    this.situacaoArquivosCarregados.push(true);
    this.atualizarEstadosUpload();
    const index = this.arquivos.indexOf(arquivo);

    const reader = new FileReader();
    reader.readAsDataURL(item.file as unknown as File);
    const subscription = new Subscription();

    reader.onload = () => {
      if (reader.result) {
        arquivo.dados = (reader.result as string).split(',')[1];
        arquivo.conteudo = reader.result as string;
        arquivo.file = toRawFile(item.file);
        arquivo.percent = 100;

        this.situacaoArquivosCarregados.pop();
        this.atualizarEstadosUpload();
        this.arquivosEmit.emit(this.arquivos);

        item.onSuccess?.({}, item.file, event); // Callback de sucesso
      }
    };

    reader.onerror = () => {
      arquivo.percent = 100;
      arquivo.erro = true;
      this.notificationService.error('Atenção', 'Ocorreu um erro inesperado ao realizar o upload');
      this.situacaoArquivosCarregados.pop();
      this.atualizarEstadosUpload();

      item.onError?.({}, item.file); // Callback de erro
    };

    return subscription;
  };

  get disableUpload(): boolean {
    return this.arquivos.length >= this.limite || this.carregandoArquivos
  }

  atualizarEstadosUpload(): void {
    this.erroUpload = (this.arquivos.length && this.arquivos.some(x => x.erro)) ? true : false;
    this.carregandoArquivos = (this.arquivos?.length && this.arquivos?.length == this.situacaoArquivosCarregados?.length) ? true : false;
  }
}
